import { Flex, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';

import {
  CommentEditor,
  CommentEditorCancelButton,
  CommentEditorCreateButton,
  CommentEditorInput,
} from '~/packages/comments/CommentEditor';
import {
  ExternalOrgSelector,
  ExternalOrgSelectorProps,
} from '~/packages/comments/ExternalOrgSelector';

// Exports
export type EventLogNewThreadEditorProps = {
  externalOrgOptions?: ExternalOrgSelectorProps['externalOrgOptions'];
  onCreateThread?: (args: {
    comment: string;
    participatingOrganizationIds: string[];
  }) => Promise<void>;
};
export const EventLogNewThreadEditor = ({
  externalOrgOptions,
  onCreateThread,
}: EventLogNewThreadEditorProps) => {
  const externalDisclosure = useDisclosure({ defaultIsOpen: false });
  const [selectedExternalIds, setSelectedExternalIds] = useState<string[]>([]);
  if (!onCreateThread) return null;
  return (
    <Flex
      direction="column"
      gap="1rem"
      paddingTop="0.5rem"
      paddingBottom="1.5rem"
      paddingInline="1.5rem"
      flexShrink={0}
    >
      <CommentEditor
        hideActionsWhenEmpty={false}
        onCreate={async (comment) => {
          await onCreateThread({
            comment,
            participatingOrganizationIds:
              // Thread creator/author org ID is read implicitly from ctx.userId on the backend
              [...new Set(selectedExternalIds)],
          });

          // Clear selected IDs and unset the "Make External" toggle
          setSelectedExternalIds([]);
          externalDisclosure.onClose();
        }}
        right={
          <>
            <CommentEditorCancelButton />
            <CommentEditorCreateButton
              isDisabled={
                externalDisclosure.isOpen && selectedExternalIds.length === 0
              }
            />
          </>
        }
        left={
          externalOrgOptions &&
          externalOrgOptions.length > 0 && (
            <ExternalOrgSelector
              disclosure={externalDisclosure}
              externalOrgOptions={externalOrgOptions}
              selectedIds={selectedExternalIds}
              onChange={setSelectedExternalIds}
            />
          )
        }
      >
        <CommentEditorInput
          isEditable
          placeHolderText="Create a new thread..."
        />
      </CommentEditor>
    </Flex>
  );
};
